const isPayload = (obj: unknown): obj is { ball?: string | number, maxball?: string | number } => {
  if (typeof obj !== "object" || obj === null) return false;

  const maybe = obj as Record<string, unknown>;

  return (
    ("ball" in maybe || "maxball" in maybe)
  );
};

export const formatTestResult = (payload: unknown) => {
  if (!isPayload(payload)) return undefined;

  if (payload.ball == null || payload.maxball == null) {
    return undefined;
  }

  const ball = Number(payload.ball);
  const maxball = Number(payload.maxball);

  if (!Number.isFinite(ball) || !Number.isFinite(maxball) || maxball === 0) {
    return undefined;
  }

  const percent = Math.round((ball / maxball) * 100);

  return `${payload.ball} из ${payload.maxball} (${percent}%)`;
};
